import "./Menu.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import logo from "../images/logo.png";
import DateComponent from "./DateComponent";

const MENU_ITEMS = [
  { label: "Start", path: "/" },
  { label: "Oferta", path: "/fotografia-wnetrz-i-nieruchomosci" },
  { label: "Zdjęcia z drona", path: "/zdjecia-z-drona" },
  { label: "Fotografia wnętrz", path: "/fotograf-wnetrz" },
  { label: "Fotografia nieruchomości", path: "/fotografia-nieruchomosci" },
  { label: "Fotografia restauracji i hoteli", path: "/fotografia-restauracji-warszawa" },
  { label: "Galeria", path: "/galeria-wnetrz-i-nieruchomosci" },
  { label: "O mnie", path: "/tomasz-fotograf" },
  { label: "Kontakt", path: "/kontakt-tomasz-fotograf" },
  { label: "FAQ", path: "/faq" },
];

export default function Menu() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const currentPath = location.pathname;
    const foundIndex = MENU_ITEMS.findIndex(
      (item) => item.path === currentPath
    );
    if (foundIndex !== -1) {
      setActiveIndex(foundIndex);
      localStorage.setItem("activeMenuIndex", foundIndex);
    }
  }, [location.pathname]);

  const handleMenuClick = (idx) => {
    setActiveIndex(idx);
    localStorage.setItem("activeMenuIndex", idx);
    setMenuOpen(false);
    navigate(MENU_ITEMS[idx].path);
  };

  return (
    <nav className="main-nav">
      <div
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span />
        <span />
        <span />
      </div>
      <div className="date-component">
        <DateComponent />
      </div>
      <img src={logo} alt="Fotograf Tomasz Jaskulski" width="80px" />
      <ul className={menuOpen ? "open" : ""}>
        {MENU_ITEMS.map((item, idx) => (
          <li key={item.path}>
            <button
              className={`menu-link montserrat-4 menu-item${
                activeIndex === idx ? " active" : ""
              }`}
              onClick={() => handleMenuClick(idx)}
            >
              {item.label}
              <span className="underline" />
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
